"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const App_1 = require("./App");
// Find the element in which to render the UI.
const main = document.getElementById('main');
if (main === null)
    throw new Error('Uh oh! Could not find the "main" element.');
// Show the UI in this place.
const root = (0, client_1.createRoot)(main);
root.render(react_1.default.createElement(App_1.App, null));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsa0RBQTBCO0FBQzFCLDZDQUFvRDtBQUNwRCwrQkFBNEI7QUFHNUIsOENBQThDO0FBQzlDLE1BQU0sSUFBSSxHQUFxQixRQUFRLENBQUMsY0FBYyxDQUFDLE1BQU0sQ0FBQyxDQUFDO0FBQy9ELElBQUksSUFBSSxLQUFLLElBQUk7SUFDZixNQUFNLElBQUksS0FBSyxDQUFDLDJDQUEyQyxDQUFDLENBQUE7QUFFOUQsNkJBQTZCO0FBQzdCLE1BQU0sSUFBSSxHQUFTLElBQUEsbUJBQVUsRUFBQyxJQUFJLENBQUMsQ0FBQztBQUNwQyxJQUFJLENBQUMsTUFBTSxDQUFDLDhCQUFDLFNBQUcsT0FBRSxDQUFDLENBQUMifQ==